import { api as base } from "utils/api";
import type {
  ManagerPaymentResponse,
  ManagerPaymentParams,
} from "types/ManagerPayment";
import { serializeRepeatParams } from "./serialize";

export type { ManagerPaymentParams } from "types/ManagerPayment";

const PATH = "/dashboard/manager"; // baseURL(REACT_APP_API)에 /api 포함

export const getManagerPayment = async (
  params: ManagerPaymentParams
): Promise<ManagerPaymentResponse> => {
  const { data } = await base.get<ManagerPaymentResponse>(`${PATH}/payment`, {
    params,
    paramsSerializer: serializeRepeatParams,
  });
  return data;
};
